// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__RexHa","title":"styles_title__dIWT4","info":"styles_info__E2A1Y","activationButton":"styles_activationButton__A_vjf","icon":"styles_icon__93DTN"};
module.exports.__checksum = "a84660dd3590"
